<template>
	<div>
		<el-dialog title="用户注销协议" :close-on-click-modal="false" :visible.sync="destroycount" width="675px" append-to-body>
			<div class="box">
				<div v-html="params.destroycount">

				</div>
			</div>
			<div class="footer">
				<button @click="destroycount = false">关闭</button>
			</div>
		</el-dialog>
		<el-dialog title="国联易拍网络拍卖使用协议" :close-on-click-modal="false" :visible.sync="platform_agreement" width="675px" append-to-body>
			<div class="box">
				<div v-html="params.platform_agreement">

				</div>
			</div>
			<div class="footer">
				<button @click="platform_agreement = false">关闭</button>
			</div>
		</el-dialog>


		<el-dialog title="国联易拍隐私政策" :close-on-click-modal="false" :visible.sync="privacy_agreement" width="675px" append-to-body>
			<div class="box">
				<div v-html="params.privacy_agreement">

				</div>
			</div>
			<div class="footer">
				<button @click="privacy_agreement = false">关闭</button>
			</div>
		</el-dialog>

		<el-dialog title="国联易拍会员注册协议" :close-on-click-modal="false" :visible.sync="reg_agreement" width="675px" append-to-body>
			<div class="box">
				<div v-html="params.reg_agreement">

				</div>
			</div>
			<div class="footer">
				<button @click="reg_agreement = false">关闭</button>
			</div>
		</el-dialog>

		<el-dialog title="国联易拍拍卖规则" :close-on-click-modal="false" :visible.sync="reg_rule" width="675px" append-to-body>
			<div class="box">
				<div v-html="params.reg_rule">

				</div>
			</div>
			<div class="footer">
				<button @click="reg_rule = false">关闭</button>
			</div>
		</el-dialog>

		<el-dialog title="国联易拍用户服务协议" :close-on-click-modal="false" :visible.sync="service_agreement" width="675px" append-to-body>
			<div class="box">
				<div v-html="params.service_agreement">

				</div>
			</div>
			<div class="footer">
				<button @click="service_agreement = false">关闭</button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import {
		getSiteConfig
	} from '@/api/config/index.js';
	export default {
		name: 'config',
		data() {
			
			return {
				loading: false,
				destroycount: false, //用户注销协议1
				platform_agreement: false, //拍卖使用协议2
				privacy_agreement: false, //隐私政策3
				reg_agreement: false, //会员注册协议4
				reg_rule: false, //拍卖规则5
				service_agreement: false, //用户服务协议6
				params: {
					destroycount: null, //用户注销协议
					platform_agreement: null, //拍卖使用协议
					privacy_agreement: null, //隐私政策
					reg_agreement: null, //会员注册协议
					reg_rule: null, //拍卖规则
					service_agreement: null, //用户服务协议
				}
			}
		},
		props: {
			isShowMask: {
				type: Number,
				default: 0
			},
		},
		watch: {
			isShowMask: {
				handler(newVal,oldVal) {
					if (newVal === 1) {
						this.destroycount = true
					}else if (newVal === 2) {
						this.platform_agreement = true
					}else if (newVal === 3) {
						this.privacy_agreement = true
					}else if (newVal === 4) {
						this.reg_agreement = true
					}else if (newVal === 5) {
						this.reg_rule = true
					}else if (newVal === 6) {
						this.service_agreement = true
					}
				},
				immediate: true
			},
		},
		created() {
			this.config();
		},
		methods: {
			async config() {
				try {
					let res = await getSiteConfig();
					if (res.code === 1) {
						this.params.destroycount = res.data.protocol.destroycount;
						this.params.platform_agreement = res.data.protocol.platform_agreement;
						this.params.privacy_agreement = res.data.protocol.privacy_agreement;
						this.params.reg_agreement = res.data.protocol.reg_agreement;
						this.params.reg_rule = res.data.protocol.reg_rule;
						this.params.service_agreement = res.data.protocol.service_agreement;
						// if (this.$route.query.config == '1') {
						// 	this.destroycount = true
						// } else if (this.$route.query.config == '2') {
						// 	this.platform_agreement = true
						// } else if (this.$route.query.config == '3') {
						// 	this.privacy_agreement = true
						// } else if (this.$route.query.config == '4') {
						// 	this.reg_agreement = true
						// } else if (this.$route.query.config == '5') {
						// 	this.reg_rule = true
						// } else if (this.$route.query.config == '6') {
						// 	this.service_agreement = true
						// }
					}
				} catch (err) {

				} finally {
					
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.box {
		width: 100%;
		min-height: 500px;
	}

	.footer {
		width: 100%;
		margin: 0 auto;
		margin-top: 20px;
		height: 46px;
		display: flex;
		align-items: center;
		justify-content: right;

		button {
			width: 160px;
			height: 46px;
			background: #0E71BC;
			border-radius: 56px 56px 56px 56px;
			color: #fff;

			&:active {
				transform: scale(0.98);
			}
		}
	}
</style>
<style scoped>
	/deep/.el-dialog {
		border-radius: 16px 16px 0px 0px;
	}

	/deep/.el-dialog__header {
		padding: 0;
		width: 100%;
		height: 64px;
		background-color: #0E71BC;
		border-radius: 16px 16px 0px 0px;
		padding: 20px;

	}

	/deep/.el-dialog__title {
		font-weight: 500;
		font-size: 20px;
		color: #fff;
	}

	/deep/.el-dialog__headerbtn {
		position: absolute;
		top: 10px;
		right: 20px;
		padding: 0;
		background: 0 0;
		border: none;
		outline: 0;
		cursor: pointer;
		font-size: 32px;
		color: #333;
	}

	/deep/.el-dialog__body {
		padding: 20px;
	}
</style>